var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FFCCDB",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.8,
    d: "M10.632 24.167v-7.273h2.87c.551 0 1.021.105 1.41.316.388.208.684.498.887.87.206.37.31.796.31 1.278 0 .483-.105.91-.313 1.279-.209.37-.51.657-.906.863-.393.206-.869.309-1.427.309h-1.83v-1.233h1.581c.296 0 .54-.05.731-.152.195-.104.339-.248.434-.43.097-.185.145-.396.145-.636 0-.241-.048-.452-.145-.632a.973.973 0 0 0-.434-.422c-.194-.102-.44-.153-.738-.153H12.17v6.016h-1.538zm9.253 0h-2.578v-7.273h2.6c.73 0 1.36.146 1.889.437.527.289.934.704 1.218 1.246.286.542.43 1.191.43 1.946 0 .758-.144 1.409-.43 1.953a2.953 2.953 0 0 1-1.226 1.254c-.53.291-1.164.437-1.903.437zm-1.04-1.318h.976c.455 0 .837-.08 1.147-.241.313-.164.547-.416.703-.757.159-.343.238-.786.238-1.328 0-.537-.08-.976-.238-1.317a1.54 1.54 0 0 0-.7-.753c-.31-.161-.692-.242-1.146-.242h-.98v4.638zm5.937 1.318v-7.273h4.816v1.268H26.32v1.733h2.958v1.267H26.32v3.005h-1.538z"
  })));
};
export default SvgPdf;